// about moment
// Copyright (c) JS Foundation and other contributors
//
// Permission is hereby granted, free of charge, to any person
// obtaining a copy of this software and associated documentation
// files (the "Software"), to deal in the Software without
// restriction, including without limitation the rights to use,
// copy, modify, merge, publish, distribute, sublicense, and/or sell
// copies of the Software, and to permit persons to whom the
// Software is furnished to do so, subject to the following
// conditions:
//
// The above copyright notice and this permission notice shall be
// included in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
// EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES
// OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND
// NONINFRINGEMENT. IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT
// HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER LIABILITY,
// WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING
// FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR
// OTHER DEALINGS IN THE SOFTWARE.

import resource from '../../../share/util/resourceMap';

const CST_DESTINATION_LIST = ['00', '03', '04', '05', '06', '07', '0E', '0F'];

/**
 * 読み出したデータから仕向け地の判定
 * @param {String} readData 読み出したデータ
 * @param {String} systemId システムId
 * @param route 呼び出し元のオブジェクト(this)
 */
export const readSetDestination = (readData, systemId, route) => {

  let destination = readData;
  if (!CST_DESTINATION_LIST.includes(destination)) {
    destination = '02';
  }
  // 仕向け地のためデータ型はHEX固定
  return resource.convertCstmDisplayItem('1148_1_all', destination, systemId, route, 'HEX');
};

/**
 * 入力コードからDataRecordを作成
 * @param {String} inputCode 入力されたコード
 */
export const writeSetDestination = (inputCode) => {

  const code = inputCode.toUpperCase();

  if (code.startsWith('JP')) {
    return '00';
  } else if (code.startsWith('KA') || code.startsWith('KC')) {
    return '04';
  } else if (code.startsWith('KS')) {
    return '06';
  } else if (code.startsWith('C0') || code.startsWith('C5')) {
    return '0F';
  } else if (code.startsWith('U4') || code.startsWith('U5') || code.startsWith('U6')) {
    return '0E';
  } else if (code.startsWith('EK') || code.startsWith('ER') || code.startsWith('EN')) {
    return '03';
  } else if (code.startsWith('K4')) {
    return '05';
  } else if (code.startsWith('C6')) {
    return '07';
  } else {
    return '02';
  }
};

export default {
  readSetDestination,
  writeSetDestination
};